// ContractDocuments.jsx
// Documents tab list for Contract Details Drawer

import React from "react";
import { Download, FileText, FileCode, Paperclip } from "lucide-react";

const ContractDocuments = ({ documents = [] }) => {
  if (!documents || documents.length === 0) {
    return (
      <div className="py-8 text-center text-xs text-slate-400">
        No documents attached to this contract.
      </div>
    );
  }

  return (
    <div className="space-y-3 pt-2">
      {documents.map((doc, idx) => {
        const isPdf = doc.name?.toLowerCase().endsWith(".pdf") || doc.type?.toLowerCase().includes("pdf");
        const IconComponent = isPdf ? FileText : FileCode;
        const iconBgClass = isPdf ? "bg-rose-50 text-rose-600 border-rose-200" : "bg-blue-50 text-blue-600 border-blue-200";

        return (
          <div
            key={doc.id || idx}
            className="flex items-center justify-between rounded-xl border border-slate-200/80 bg-white p-3.5 shadow-sm transition hover:border-slate-300"
          >
            <div className="flex items-center gap-3 min-w-0 pr-2">
              <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border ${iconBgClass}`}>
                <IconComponent size={18} strokeWidth={2} />
              </div>
              <div className="min-w-0">
                <p className="text-xs font-semibold text-slate-800 truncate">
                  {doc.name}
                </p>
                <p className="mt-0.5 text-[11px] text-slate-400">
                  {doc.size || "Unknown size"} • Uploaded {doc.uploaded_date || "recently"} by {doc.uploaded_by || "System"}
                </p>
              </div>
            </div>

            <button
              type="button"
              onClick={() => window.open(doc.url || "#", "_blank")}
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-700 transition"
              title="Download Document"
            >
              <Download size={16} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default ContractDocuments;
